import gql from "graphql-tag";

export const TEAMS_MApp_PULSE_CHECK = gql`
  query reportingTeamsMAppPulseCheck {
    reportingTeamsMAppPulseCheck
  }
`;
